import { extendTheme } from "@chakra-ui/react";
import { defineStyleConfig } from "@chakra-ui/react";
import "@fontsource/montserrat"; // Import Montserrat font

const Button = defineStyleConfig({
  variants: {
    solidBlue: {
      mt: 6,
      bg: "#00aeef",
      color: "white",
      _hover: {
        bg: "#1c4b7e",
      },
      _focus: {
        boxShadow: "0 0 0 3px rgba(0, 174, 239, 0.5)",
      },
      _active: {
        bg: "#1c4b7e",
        transform: "scale(0.98)",
      },
      size: "lg",
      w: "full",
    },
  },
});
const theme = extendTheme({
  styles: {
    global: {
      "html, body": {
        backgroundColor: "#ffffff",
        color: "inherit",
        fontFamily: "Montserrat, sans-serif", // Set Montserrat as default font
      },
    },
  },
  fonts: {
    heading: "Montserrat, sans-serif", // Use Montserrat for headings
    body: "Montserrat, sans-serif", // Use Montserrat for body text
  },
  components: {
    Input: {
      baseStyle: {
        bg: "white", // ✅ Default white background
        _focus: {
          bg: "white", // ✅ Keep it white on focus
        },
        _hover: {
          bg: "white", // ✅ Keep it white on hover
        },
      },
    },
    Button,
  },
});

export default theme;
